import CaseHelper from "../../../../utilities/CaseHelper";
import { CaseName } from "../../../../components/case/CaseName";
import { IUserModel } from "../../../../interfaces/IUser";
import { useCaseFileContext } from "../../../../contexts/useCaseFileContext";
import { useZoneContext } from "../../../../contexts/useZoneContext";

export interface ICaseResolutionHeaderProps {
    onSettingsClick: () => void;
    handleLogClick: () => void;
    user: IUserModel;
}

export function CaseResolutionHeader({
    onSettingsClick,
    handleLogClick,
    user,
}: ICaseResolutionHeaderProps) {
    const { currentCase, isReadOnlyMode, setIsReadOnlyMode } = useCaseFileContext();
    const zoneContext = useZoneContext();

    return (
        <>
            <h1 style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                    <CaseName
                        additionalText=" - Case Resolution Work Flow"
                        caseTitle={CaseHelper.getCaseTitle(currentCase, false)}
                        zoneContext={zoneContext}
                        caseGuid={currentCase.guid}
                    />
                </div>
                <span className="float-end print-hide-display">
                    <span>
                        <button
                            className="btn btn-no-bg float-end text-gray"
                            onClick={onSettingsClick}
                        >
                        <i className="fal fa-gear" />
                            &nbsp;Settings
                        </button>
                        <button
                            className="btn btn-no-bg float-end text-gray"
                            onClick={handleLogClick}
                        >
                        <i className="fal fa-memo" />
                            &nbsp;Work Log
                        </button>
                    </span>
                </span>
            </h1>
        </>
    )
}